
import { motion } from "framer-motion";
import { GraduationCap, ArrowRight, Sparkles, Target, BookOpenCheck } from "lucide-react";
import { Button } from "@/components/ui/button";

interface QuizIntroProps {
  onStart: () => void;
  onSkip: () => void;
}

const QuizIntro = ({ onStart, onSkip }: QuizIntroProps) => {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.5 }}
      className="w-full text-center"
    >
      <div className="relative">
        <div className="absolute -top-10 -right-6 opacity-70">
          <Sparkles className="w-12 h-12 text-[#FBC528]" />
        </div>
        
        <div className="mb-10 flex justify-center">
          <div className="w-24 h-24 bg-gradient-to-br from-[#EBF2F9] to-[#D3E4FD] rounded-full flex items-center justify-center shadow-lg">
            <GraduationCap className="w-12 h-12 text-hero-mid" />
          </div>
        </div>
      </div>
      
      <h2 className="text-3xl sm:text-4xl font-bold text-[#012B48] mb-6 leading-tight">
        Welcome to the Crypto Trading Quiz!
      </h2>
      
      <div className="space-y-5 mb-10 max-w-xl mx-auto">
        <p className="text-lg text-[#414D6B] leading-relaxed">
          This quick quiz will help us understand your trading knowledge and find the perfect strategies for you.
        </p>
        <p className="text-lg text-[#414D6B] leading-relaxed">
          Answer 5 simple questions about crypto trading basics and we'll personalize your experience.
        </p>
      </div>
      
      <div className="max-w-md mx-auto bg-gradient-to-br from-[#F8FAFD] to-[#EDF5FF] border border-[#E5E9F2] rounded-xl p-6 mb-10 shadow-sm">
        <div className="grid grid-cols-1 gap-4">
          <div className="flex items-start space-x-3">
            <div className="flex-shrink-0 bg-[#FEF7CD] p-2 rounded-lg">
              <Target className="w-5 h-5 text-[#FBC528]" />
            </div>
            <div className="text-left">
              <span className="text-[#414D6B] font-medium">Discover your risk tolerance</span>
            </div>
          </div>
          
          <div className="flex items-start space-x-3">
            <div className="flex-shrink-0 bg-[#E5DEFF] p-2 rounded-lg">
              <BookOpenCheck className="w-5 h-5 text-[#407096]" />
            </div>
            <div className="text-left">
              <span className="text-[#414D6B] font-medium">Learn crypto trading fundamentals</span>
            </div>
          </div>
          
          <div className="flex items-start space-x-3">
            <div className="flex-shrink-0 bg-[#D3E4FD] p-2 rounded-lg">
              <Sparkles className="w-5 h-5 text-[#012B48]" />
            </div>
            <div className="text-left">
              <span className="text-[#414D6B] font-medium">Get personalized strategy recommendations</span>
            </div>
          </div>
        </div>
      </div>
      
      <div className="flex flex-col items-center gap-6">
        <Button
          onClick={onStart}
          className="bg-gradient-to-r from-hero-mid to-hero-dark hover:from-hero-dark hover:to-hero-mid text-white px-10 py-6 text-lg rounded-xl shadow-md transition-all duration-300 transform hover:scale-105"
        >
          Start the Quiz
          <ArrowRight className="ml-2 w-5 h-5" />
        </Button>
        
        <button
          onClick={onSkip}
          className="text-gray-500 hover:text-gray-700 text-sm underline transition-colors"
        >
          Skip Quiz
        </button>
      </div>
    </motion.div>
  );
};

export default QuizIntro;
